import styled from "styled-components";
import React from "react";

export const Container = styled.div`
  position: relative;
  overflow: hidden;
  margin-top: 16px;
  display: flex;
  justify-content: center; /* 가로축 중앙 정렬 */
  align-items: center; /* 세로축 중앙 정렬 */

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
  &:hover {
      opacity: 0.8;
  }
  cursor: pointer;
`;
